import type { GameCredentials, ScholarshipApplication } from '@olagg/db-types'
import { useState } from 'react'
import { ScholarshipsEndpoints } from '../endpoints/endpoints'
import { fetcher } from '../fetcher'

export const useMyScholarship = () => {
  const [scholarship, setScholarship] = useState<ScholarshipApplication>()

  const getScholarship = (slug: string): Promise<ScholarshipApplication> =>
    fetcher(ScholarshipsEndpoints.myScholarship(slug))
      .then((data) => {
        setScholarship(data.scholarship)
        return data.scholarship
      })

  const getScholarshipById = (id: string): Promise<ScholarshipApplication> =>
    fetcher(ScholarshipsEndpoints.byId(id))
      .then((data) => {
        setScholarship(data.scholarship)
        return data.scholarship
      })

  const updateCredentials = (id: string, data: Partial<GameCredentials>) =>
    fetcher(ScholarshipsEndpoints.updateMyCredentials(id, data)
    )

  return {
    updateCredentials,
    getScholarship,
    scholarship,
    getScholarshipById
  }
}
